<template>
  <div class="app-container">
    <div class="jk-w-full jk-h-[75px] jk-bg-[linear-gradient(0deg,#ffffff03_5%,#cce1fc8c_100%)] jk-rounded-[4px] jk-flex jk-items-center jk-justify-between jk-px-[24px] jk-gap-x-[30px]">
      <div class="jk-flex jk-items-center jk-gap-[30px]">
        <div class="jk-flex jk-items-center jk-gap-x-[6px]">
          <svg-icon class-name="!jk-w-[12px] !jk-h-[12px]" icon-class="right" />
          <span class="jk-text-[#636B71] jk-text-[13px]">校区名称</span>
          <span class="jk-text-[#006DFF] jk-text-[13px] jk-min-w-[80px]">{{ detailData.deptName }}</span>
        </div>
         <div class="jk-flex jk-items-center jk-gap-x-[6px]">
          <svg-icon class-name="!jk-w-[12px] !jk-h-[12px]" icon-class="right" />
          <span class="jk-text-[#636B71] jk-text-[13px]">客户名称</span>
          <span class="jk-text-[#006DFF] jk-text-[13px] jk-min-w-[80px]">{{ detailData.leader }}</span>
        </div>
         <div class="jk-flex jk-items-center jk-gap-x-[6px]">
          <svg-icon class-name="!jk-w-[12px] !jk-h-[12px]" icon-class="right" />
          <span class="jk-text-[#636B71] jk-text-[13px]">手机号码</span>
          <span class="jk-text-[#006DFF] jk-text-[13px] jk-min-w-[80px]">{{ detailData.phone }}</span>
        </div>
         <div class="jk-flex jk-items-center jk-gap-x-[6px]">
          <svg-icon class-name="!jk-w-[12px] !jk-h-[12px]" icon-class="right" />
          <span class="jk-text-[#636B71] jk-text-[13px]">所在区域</span>
          <span class="jk-text-[#006DFF] jk-text-[13px] jk-min-w-[80px]">{{ detailData.region }}</span>
        </div>
         <div class="jk-flex jk-items-center jk-gap-x-[6px]">
          <svg-icon class-name="!jk-w-[12px] !jk-h-[12px]" icon-class="right" />
          <span class="jk-text-[#636B71] jk-text-[13px]">状态</span>
          <span class="jk-text-[#006DFF] jk-text-[13px] jk-min-w-[80px]">
            <dict-tag :options="dict.type.sys_normal_disable" :value="detailData.status" />
          </span>
        </div>
         <div class="jk-flex jk-items-center jk-gap-x-[6px]">
          <svg-icon class-name="!jk-w-[12px] !jk-h-[12px]" icon-class="right" />
          <span class="jk-text-[#636B71] jk-text-[13px]">有效期</span>
          <span class="jk-text-[#006DFF] jk-text-[13px] jk-min-w-[80px]">{{ detailData.validityPeriod }}</span>
        </div>
      </div>
      <el-button
        class="el-button !jk-bg-[linear-gradient(90deg,#a855f7_0%,#ec4899_100%)] !jk-text-white !jk-px-[20px] !jk-py-[8px] el-button--primary el-button--medium"
        size="small"
        type="primary"
        @click="drawerVisible = true"
      >充值套餐</el-button>
    </div>

    <!-- 充值套餐抽屉 -->
    <el-drawer
      :visible.sync="drawerVisible"
      title="选择充值套餐"
      direction="rtl"
      size="600px"
      @open="fetchOnSalePackageList"
    >
      <div class="jk-px-[20px]">
        <el-skeleton :loading="packageLoading" animated :count="4" v-if="packageLoading">
          <template slot="template">
            <div class="jk-rounded-[12px] jk-p-[20px] jk-border jk-border-solid jk-border-[#E5E7EB]">
              <el-skeleton-item variant="text" style="width: 60%; height: 20px;" />
              <el-skeleton-item variant="text" style="width: 40%; height: 32px; margin-top: 12px;" />
              <el-skeleton-item variant="text" style="width: 100%; height: 14px; margin-top: 8px;" />
              <el-skeleton-item variant="button" style="width: 100%; height: 32px; margin-top: 16px;" />
            </div>
          </template>
        </el-skeleton>
        <div
          class="jk-grid jk-grid-cols-2 jk-gap-[12px]"
          v-else-if="packageList.length > 0"
        >
        <div
          v-for="item in packageList"
          :key="item.id"
          class="jk-rounded-[12px] jk-p-[20px] jk-border jk-border-solid jk-border-[#E5E7EB] jk-bg-white hover:jk-shadow-md jk-transition-shadow jk-cursor-pointer"
        >
          <div class="jk-text-[16px] jk-font-bold jk-text-[#1F2937]">{{ item.name }}</div>
          <div class="jk-flex jk-items-baseline jk-gap-x-[4px] jk-mt-[12px]">
            <span class="jk-text-[24px] jk-font-bold jk-text-[#EF4444]">¥{{ item.price / 100 }}</span>
            <span class="jk-text-[14px] jk-text-[#9CA3AF]">/{{ item.days }}天</span>
          </div>
          <div class="jk-text-[13px] jk-text-[#6B7280] jk-mt-[8px]" v-if="item.desc">{{ item.desc }}</div>
          <el-button
            type="primary"
            size="small"
            class="!jk-w-full !jk-mt-[16px]"
            @click="handleRecharge(item)"
          >立即充值</el-button>
        </div>
      </div>
    </div>
    </el-drawer>

    <!-- 确认充值弹窗 -->
    <el-dialog
      :visible.sync="rechargeDialogVisible"
      title="确认充值"
      width="420px"
      @close="rechargeQuantity = 1"
    >
      <div class="jk-p-[16px] jk-bg-[#F9FAFB] jk-rounded-[8px]" v-if="selectedPackage">
        <div class="jk-text-[14px] jk-text-[#6B7280]">选择的套餐</div>
        <div class="jk-flex jk-items-center jk-justify-between jk-mt-[8px]">
          <span class="jk-text-[16px] jk-font-bold jk-text-[#1F2937]">{{ selectedPackage.name }}</span>
          <span class="jk-text-[20px] jk-font-bold jk-text-[#EF4444]">¥{{ selectedPackage.price / 100 }}</span>
        </div>
        <div class="jk-text-[13px] jk-text-[#9CA3AF] jk-mt-[4px]">单价: ¥{{ selectedPackage.price / 100 }}/{{ selectedPackage.days }}天</div>
      </div>
      <div class="jk-mt-[20px] jk-flex jk-items-center jk-justify-between jk-px-[4px]">
        <span class="jk-text-[14px] jk-text-[#374151]">充值数量</span>
        <el-input-number
          v-model="rechargeQuantity"
          :min="1"
          :max="999"
          :step="1"
          controls-position="right"
          size="small"
        ></el-input-number>
      </div>
      <span slot="footer">
        <el-button size="small" @click="rechargeDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="rechargeLoading" @click="confirmRecharge">确认充值</el-button>
      </span>
    </el-dialog>

    <div class="jk-flex-1 jk-mt-[20px]">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="校区套餐" name="first">
          <div>
            <div
              class="statistics-box"
              v-loading="schoolPackageLoading"
              element-loading-text="加载中..."
              v-if="schoolPackageNumList && schoolPackageNumList.length"
            >
              <div v-for="item in schoolPackageNumList" :key="item.sysPackageId">
                <div class="stat-card">
                  <div class="stat-card-content">
                    <img src="@/assets/images/vip.png" alt="" />
                    <div class="stat-card-text">
                      <div class="stat-value jk-flex jk-items-end">
                        <div class="stat-value">{{ item.num }}<span>个</span></div>
                        <div class="jk-text-[#9ca3af] jk-text-[20px] jk-mx-[10px]">/</div>
                        <div class="stat-value">{{ item.totalNum }}<span>个</span></div>
                      </div>
                      <div class="stat-label">
                        {{ item.name }}({{ item.days }}天)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-empty v-else-if="!schoolPackageLoading" description="暂无已充值套餐" />
          </div> 
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import { listSchoolPackage, listOnSalePackage, addRecharge } from '@/api/modules/campus';

  export default {
    name: 'CampusDetail',
    dicts: ['sys_normal_disable'],
    data() {
      return {
        campusInfo: {},
        loading: false,
        activeName: 'first',
        // 抽屉
        drawerVisible: false,
        // 充值套餐列表
        packageList: [],
        packageLoading: false,
        // 确认充值弹窗
        rechargeDialogVisible: false,
        selectedPackage: null,
        rechargeQuantity: 1,
        rechargeLoading: false,
        // 已充值套餐列表
        schoolPackageNumList: [],
        schoolPackageLoading: false,
      };
    },
    computed: {
      detailData() {
        const params = this.$route.params;
        return {
          deptName: params.deptName || '-',
          leader: params.leader || '-',
          phone: params.phone || '-',
          region: [params.provinceName, params.cityName, params.areaName].filter(Boolean).join(' ') || '-',
          status: params.status,
          validityPeriod: params.validityPeriod || '-',
        };
      },
      totalAmount() {
        if (!this.selectedPackage) return 0;
        return (this.selectedPackage.price * this.rechargeQuantity).toFixed(2);
      },
    },
    created() {
      const params = this.$route.params;
      const deptId = params.deptId;
      if (!deptId || params.deptName === undefined) {
        this.goBack();
      } else {
        this.fetchSchoolPackageList(deptId);
      }
    },
    methods: {
      /** 获取校区已购套餐列表 */
      fetchSchoolPackageList(deptId) {
        this.schoolPackageLoading = true;
        listSchoolPackage(deptId)
          .then((res) => {
            this.schoolPackageNumList = res.data || [];
          })
          .catch((err) => {
            this.$modal.msgError(err.msg || '获取已购套餐列表失败');
          })
          .finally(() => {
            this.schoolPackageLoading = false;
          });
      },
      /** 获取可充值套餐列表 */
      fetchOnSalePackageList() {
        this.packageLoading = true;
        listOnSalePackage()
          .then((res) => {
            this.packageList = res.data || [];
          })
          .catch((err) => {
            this.$modal.msgError(err.msg || '获取可充值套餐列表失败');
          })
          .finally(() => {
            this.packageLoading = false;
          });
      },
      /** 点击立即充值 */
      handleRecharge(item) {
        this.selectedPackage = item;
        this.rechargeQuantity = 1;
        this.rechargeDialogVisible = true;
      },
      /** 确认充值 */
      confirmRecharge() {
        this.rechargeLoading = true;
        const deptId = this.$route.params.deptId;
        addRecharge({
          deptId: deptId,
          sysPackageId: this.selectedPackage.sysPackageId,
          num: this.rechargeQuantity,
          price: 0,
          phone: this.$route.params.phone,
        }).then(() => {
          this.$modal.msgSuccess('充值成功');
          this.rechargeDialogVisible = false;
          this.drawerVisible = false;
          this.fetchSchoolPackageList(deptId);
        })
        .catch((err) => {
          this.$modal.msgError(err.msg || '充值失败');
        })
        .finally(() => {
          this.rechargeLoading = false;
        });
      },
      goBack() {
        this.$router.back();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-descriptions {
    margin-top: 20px;
  }

  .statistics-box {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 15px;

    .stat-card {
      display: flex;
      align-items: center;
      width: 280px;
      height: 108px;
      background: linear-gradient(180deg, #ffffff 0%, #f5f8ff 100%);
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      padding: 20px;

      .stat-card-content {
        display: flex;
        align-items: center;
        gap: 16px;
        width: 100%;
        height: 100%;

        img {
          width: 58px;
          height: 58px;
          flex-shrink: 0;
        }

        .stat-card-text {
          display: flex;
          flex-direction: column;

          .stat-value {
            font-size: 28px;
            font-weight: bold;
            color: #1f2937;
            line-height: 1.2;

            span {
              font-size: 14px;
              font-weight: normal;
              color: #9ca3af;
              margin-left: 4px;
            }
          }

          .stat-label {
            font-size: 13px;
            color: #6b7280;
            margin-top: 4px;
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>
